import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { Table, TableCell, TableContainer, TableRow, TableHead, TableBody, Box, FormControl, Button, CircularProgress } from '@mui/material';
import moment from "moment";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import PieChart from "components/inner/chart/PieChart";
import CommonExcelDownload from "components/CommonExcelDownload";
import BarChart from "components/inner/chart/BarChart";
import CustomEnumSelect from "components/select/CustomEnumSelect";
import { getEquipmentAlertsDiagnosisByQueryString } from "components/axios/equipmentAlertsAxios";
import { useEnumApi } from 'contexts/EnumApiContext';
import PageInfo from "components/PageInfo";
import { useEffect } from "react";
import { getReportCountEquipmentAlertGroupByCtgr1AndSubwayLineByQuery, getReportCountEquipmentAlertGroupByDiagnosisCodesAndSubwayLineByQuery } from "components/axios/reportAxios";
import { reverseOrderNumber } from "data/data";
import CustomDatePicker2 from "components/date_picker/CustomDatePicker2";
import { Height } from "@mui/icons-material";

const AlertstatusReportReportDataroomAlertstatusReport = () => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
               // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const [isLoading, setIsLoading] = useState(false);

    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const handlePaging = (value) => {
        value = isNaN(value) ? 1 : value;
        setCurrentPage(value-1);
        setIsLoading(false);
    }

    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const today = dayjs(new Date()).format('YYYY-MM-DD');

    const [searchStartDateText, setSearchStartDateText] = useState(today);
    const [searchEndDateText, setSearchEndDateText] = useState(today);

    const [pieDatas, setPieDatas] = useState([]);
    const [barData, setBarData] = useState(null);

    const [reportTitle, setReportTitle] = useState("");

    const excelTopHeaders = [t('message.common.subtitle.main.category'), t('message.common.subtitle.total.count'), t('message.common.subtitle.one.subwayline'), t('message.common.subtitle.two.subwayline')];
    const [fileName, setFileName] = useState("");
    const [reports, setReports] = useState([]);
    const [excelDatas, setExcelDatas] = useState([]);

    const excelTopHeader2s = [
        // t('message.common.subtitle.subwayline'), t('message.common.subtitle.workingPart'), t('message.common.subtitle.station'), 
        t('message.common.subtitle.equipment.level1'), t('message.common.subtitle.equipment.level3'),
        t('message.common.subtitle.equipment.name'),t('message.common.subtitle.equipment.number'),t('message.common.subtitle.alertType'),t('message.common.subtitle.alertCategory'), t('message.common.subtitle.defect.name'),t('message.common.subtitle.fllwActionType'),t('message.common.subtitle.alertedAt')];
    const [fileName2, setFileName2] = useState("");
    const [report2s, setReport2s] = useState([]);
    const [excelData2s, setExcelData2s] = useState([]);

    const excelTopHeader3s = [t('message.common.subtitle.defect.name'), t('message.common.subtitle.total.count'), t('message.common.subtitle.one.subwayline'), t('message.common.subtitle.two.subwayline')];
    const [fileName3, setFileName3] = useState("");
    const [report3s, setReport3s] = useState([]);
    const [excelData3s, setExcelData3s] = useState([]);

    const selectParam = () => {
        if (searchStartDateText === null || searchStartDateText === '' || searchEndDateText === null || searchEndDateText === '') {
            alertMessage = t('message.common.alert.period.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (searchStartDateText === null || searchStartDateText === '' || !regexDate.test(searchStartDateText)) {
            alertMessage = t('message.common.alert.date.exactly.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (searchEndDateText === null || searchEndDateText === '' || !regexDate.test(searchEndDateText)) {
            alertMessage = t('message.common.alert.date.exactly.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        setCurrentPage(0);
        pageInfo.number = 0;
        setPageInfo(pageInfo);
        equipmentAlertList(0);        
    }

    useEffect(()=> {
        if (!isLoading && !isNaN(currentPage) && searchStartDateText != null && searchStartDateText != '' && searchEndDateText != null && searchEndDateText != '') {
            equipmentAlertList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, isLoading, pageSize]);

    function equipmentAlertList(curPage=currentPage) {
        isNaN(curPage) && setCurrentPage(0);
        isNaN(pageSize) && setPageSize(50);
        let param = {
            page: curPage,
            size : pageSize,
            sort: "latestAlertedAt,asc"
        };

        let addQueryString = "";
        if (searchStartDateText && searchEndDateText) {
            let startDay = new Date(searchStartDateText);
            addQueryString += "&latestAlertedAt=gte(" + encodeURIComponent(moment(new Date(startDay.getFullYear(), startDay.getMonth(), startDay.getDate(), 0, 0, 0)).format());
            let endDay = new Date(searchEndDateText);
            addQueryString += ")&latestAlertedAt=and(lte(" + encodeURIComponent(moment(new Date(endDay.getFullYear(), endDay.getMonth(), endDay.getDate(), 23, 59, 59)).format()) + "))";
        }

        let queryString = Object.entries(param).map(([key, value]) => (value && key + '=' + value)).filter(v => v).join('&');
        queryString += addQueryString;

        let reportTitle = " "+t('menu.cmms.report-dataroom.alertstatus-report')+"(";
        reportTitle += searchStartDateText;
        reportTitle += " ~ ";
        reportTitle += searchEndDateText;
        reportTitle += ")";
        setReportTitle(reportTitle);
        setFileName(reportTitle+"_"+t('message.common.file.name.alert.status')+"_" + Date.now());
        setFileName2(reportTitle+"_"+t('message.common.file.name.alert.list')+"_" + Date.now());
        setFileName3(reportTitle+"_"+t('message.common.file.name.defect.type')+"_" + Date.now());

        Promise.all([
            getReportCountEquipmentAlertGroupByDiagnosisCodesAndSubwayLineByQuery({startDay:searchStartDateText, endDay:searchEndDateText}).then((data)=>{
                if(data && data.length > 0) {
                    setReport3s(data);

                    let excelDatas = [];
                    let excelData = [];
                    data && data.forEach((element, i) =>{
                        excelData = [];
                        let sum = element[4]+element[5];
                        excelTopHeader3s.forEach(function(hd, b) {
                            let value = element[b];
                            if (b===0) {
                                value = element[2];
                            } else if (b===1) {
                                value = sum;
                            } else if (b>1) {
                                value = element[b+2];
                            }
                            excelData.push(value);
                        })
                        excelDatas.push(excelData);
                    })
                    setExcelData3s(excelDatas);
                } else {
                    setReport3s([]);
                    setExcelData3s([]);
                }
            })
            ,getReportCountEquipmentAlertGroupByCtgr1AndSubwayLineByQuery({startDay:searchStartDateText, endDay:searchEndDateText}).then((data)=>{
                if(data && data.length > 0) {
                    setReports(data);

                    let excelDatas = [];
                    let excelData = [];
                    let pieDatas = [];
                    let pieData = {};
                    data && data.forEach((element, i) =>{
                        excelData = [];
                        let sum = element[1]+element[2];
                        excelTopHeaders.forEach(function(hd, b) {
                            let value = element[b];
                            if (b===1) {
                                value = sum;
                            } else if (b>1) {
                                value = element[b-1];
                            }
                            excelData.push(value);
                        })
                        excelDatas.push(excelData);

                        pieData = {};
                        pieData.title = element[0];
                        pieData.cnt = sum;
                        pieDatas.push(pieData);
                    })
                    setExcelDatas(excelDatas);

                    let barDatas = [...excelDatas];
                    reverseOrderNumber(barDatas, 1)
                    let barChartDatas = barDatas;
                    if (barDatas.length > 5) {
                        let copyStartBarDatas = barDatas.slice(0,5);
                        let copyEndBarDatas = barDatas.slice(5);

                        // const sum = copyEndBarDatas.reduce((accumulator, currentValue) => {
                        //     // return accumulator + currentValue[2]
                        //     return accumulator + currentValue[1]
                        // }, 0);

                        copyStartBarDatas.push([t('message.common.etc.equipment'),
                            copyEndBarDatas.reduce((accumulator, currentValue) => {
                                return accumulator + currentValue[1]
                            }, 0),
                            copyEndBarDatas.reduce((accumulator, currentValue) => {
                                return accumulator + currentValue[2]
                            }, 0),
                            copyEndBarDatas.reduce((accumulator, currentValue) => {
                                return accumulator + currentValue[3]
                            }, 0),
                            // copyEndBarDatas.reduce((accumulator, currentValue) => {
                            //     return accumulator + currentValue[4]
                            // }, 0)
                        ])

                        barChartDatas = copyStartBarDatas;
                    }
                    let series = [{name:t('message.common.subtitle.one.subwayline'),data:[]},{name:t('message.common.subtitle.two.subwayline'),data:[]},{name:t('message.common.subtitle.total.count'),data:[]}];
                    let categories = [];
                    barChartDatas && barChartDatas.forEach(function(column, a) {
                        series[0].data.push(column[2]);
                        series[1].data.push(column[3]);
                        // series[2].data.push(column[4]);
                        // series[3].data.push(column[1]);
                        series[2].data.push(column[1]);
                        categories.push(column[0]);
                    })
                    let barData = {series, categories};
                    setBarData(barData);

                    let pieChartDatas = pieDatas;
                    if (pieDatas.length > 5) {
                        let copyStartPieDatas = pieDatas.slice(0,5);
                        let copyEndPieDatas = pieDatas.slice(5);

                        // const sum = copyEndPieDatas.reduce((accumulator, currentValue) => {
                        //     // return accumulator + currentValue[2]
                        //     return accumulator + currentValue[1]
                        // }, 0);

                        copyStartPieDatas.push({title:t('message.common.etc.equipment'), cnt:
                            copyEndPieDatas.reduce((accumulator, currentValue) => {
                                return accumulator + currentValue.cnt
                            }, 0)
                        })

                        pieChartDatas = copyStartPieDatas;
                    }
                    setPieDatas(pieChartDatas);
                } else {
                    setPieDatas([]);
                    setReports([]);
                    setExcelDatas([]);
                    setBarData(null);
                }
            })
            ,
            getEquipmentAlertsDiagnosisByQueryString("?" + queryString).then((data) => {
                if (data != null) {
                    if (data.page) {
                        setPageInfo(data.page);
                    } else {
                        setCurrentPage(0);
                        pageInfo = {
                            size: pageInfo.size,
                            totalElements: 0,
                            totalPages: 0,
                            number: 0
                        };
                        setPageInfo(pageInfo);
                    }
                    if (data._embedded) {
                        let list = data._embedded.equipmentAlerts;
                        if (list) {
                            let excelDatas = [];
                            let excelData = [];
                            list && list.forEach(function (column, a) {
                                excelData = [
                                    // ((column.equipment && column.equipment.station && getEnumValueByEnumNameAndCode("SubwayLine", column.equipment.station.workingPart.subwayLine)[0].title) || ''),
                                    // ((column.equipment && column.equipment.station && column.equipment.station.workingPart.name) || ''),
                                    // ((column.equipment && column.equipment.station && column.equipment.station.name) || ''),
                                    ((column.equipment && column.equipment.equipmentCtgr && column.equipment.equipmentCtgr.parent.parent.name) || ''),
                                    ((column.equipment && column.equipment.equipmentCtgr && column.equipment.equipmentCtgr.name) || ''),
                                    ((column.equipment && column.equipment.name) || ''),
                                    ((column.equipment && column.equipment.equipmentNo) || ''),
                                    getEnumValueByEnumNameAndCode("AlertType", column.alertType)[0].title,
                                    getEnumValueByEnumNameAndCode("AlertCategory", column.alertCategory)[0].title,
                                    ((column.diagnosisCodes && column.diagnosisCodes.length > 0 && column.diagnosisCodes[0].subCategoryNm) || ''),
                                    getEnumValueByEnumNameAndCode("FollowActionType", column.fllwActionType)[0].title,
                                    dayjs(column.latestAlertedAt).format('YYYY-MM-DD HH:mm')
                                ];
                                excelDatas.push(excelData);
                            });
                            setReport2s(excelDatas);
                            return data.page.totalElements;
                        } else {
                            setReport2s([]);    
                            return 0;
                        }
                    } else {
                        setReport2s([]);
                        return 0;
                    }
                }
            })
        ]).then((res)=>{
            setIsLoading(true);
            delete param.page;
            param.page = 0;
            const totalCount = res[2];
            if (totalCount > 0) {
                param.size = totalCount;
                queryString = Object.entries(param).map(([key, value]) => (value && key + '=' + value)).filter(v => v).join('&');
                queryString += addQueryString;
                getEquipmentAlertsDiagnosisByQueryString("?" + queryString).then((data) => {
                    if (data != null) {
                        if (data._embedded) {
                            let list = data._embedded.equipmentAlerts;
                            if (list) {
                                let excelDatas = [];
                                let excelData = [];
                                list && list.forEach(function (column, a) {
                                    excelData = [
                                        // ((column.equipment && column.equipment.station && getEnumValueByEnumNameAndCode("SubwayLine", column.equipment.station.workingPart.subwayLine)[0].title) || ''),
                                        // ((column.equipment && column.equipment.station && column.equipment.station.workingPart.name) || ''),
                                        // ((column.equipment && column.equipment.station && column.equipment.station.name) || ''),
                                        ((column.equipment && column.equipment.equipmentCtgr && column.equipment.equipmentCtgr.parent.parent.name) || ''),
                                        ((column.equipment && column.equipment.equipmentCtgr && column.equipment.equipmentCtgr.name) || ''),
                                        ((column.equipment && column.equipment.name) || ''),
                                        ((column.equipment && column.equipment.equipmentNo) || ''),
                                        getEnumValueByEnumNameAndCode("AlertType", column.alertType)[0].title,
                                        getEnumValueByEnumNameAndCode("AlertCategory", column.alertCategory)[0].title,
                                        ((column.diagnosisCodes && column.diagnosisCodes.length > 0 && column.diagnosisCodes[0].subCategoryNm) || ''),
                                        getEnumValueByEnumNameAndCode("FollowActionType", column.fllwActionType)[0].title,
                                        dayjs(column.latestAlertedAt).format('YYYY-MM-DD HH:mm')
                                    ];
                                    excelDatas.push(excelData);
                                });
                                setExcelData2s(excelDatas);
                            } else {
                                setExcelData2s([]);    
                            }
                        } else {
                            setExcelData2s([]);
                        }
                    }
                })
            } else {
                setExcelData2s([]);
            }
        });
    }

    return (
        <div>
            <div>
                <Box sx={{ minWidth: 120 }}>
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <CustomDatePicker2 
                            name={"searchStartDateText"} 
                            value={searchStartDateText} 
                            onChange={(e)=>{setSearchStartDateText(e.target.value)}}
                            className='search_22'
                        />
                    </FormControl>
                    ~
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <CustomDatePicker2 
                            name={"searchEndDateText"} 
                            value={searchEndDateText} 
                            onChange={(e)=>{setSearchEndDateText(e.target.value)}}
                            className='search_22'
                        />
                    </FormControl>

                    <Link to={''}><Button variant="contained" style={{marginTop:"13px",padding:"5px 15px"}} onClick={selectParam}>{t('message.common.btn.report.generation')}</Button></Link>
                </Box>

                {reportTitle &&
                <div>
                    <p className="report-dataroom-tit">
                        {reportTitle}
                    </p>
                    <div style={{display: "flex",justifyContent:"center"}}>
                        {pieDatas && pieDatas.length > 0 && <PieChart pieDatas={pieDatas} />}
                        {barData && <BarChart barData={barData} />}
                    </div>

                    <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.file.name.defect.type')}</p>
                    <TableContainer>
                        <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('message.common.subtitle.defect.name')}</TableCell>
                                    <TableCell>{t('message.common.subtitle.total.count')}</TableCell>
                                    <TableCell>{t('message.common.subtitle.one.subwayline')}</TableCell>
                                    <TableCell>{t('message.common.subtitle.two.subwayline')}</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                            { report3s && report3s.map(function(item, i) {
                                let sum = item[4] + item[5];
                                return (
                                <TableRow key={i}>
                                    <TableCell>{item[2]}</TableCell>
                                    <TableCell>{sum}</TableCell>
                                    <TableCell>{item[4]}</TableCell>
                                    <TableCell>{item[5]}</TableCell>
                                </TableRow>
                                )
                            })}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <br/>

                    {(excelData3s && excelData3s.length > 0) ?
                    <div className="report-dataroom-button">
                        <div></div>
                        <div className='no-print-page'>
                            <CommonExcelDownload excelDatas={excelData3s} excelHeader={excelTopHeader3s} title={`${reportTitle} ${t('message.common.file.name.defect.type')}`} filename={`${fileName3}.xlsx`} />
                        </div>
                    </div>
                    :
                    (report3s && report3s.length > 0) ?
                    <div className="report-dataroom-button">
                        <div></div>
                        <div className='no-print-page' style={{color:"#000"}}>
                            <Box sx={{ display: 'flex', color:"#000" }}>
                                {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                            </Box>
                        </div>
                    </div>
                    : ''
                    }

                    <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.chip.alert.status')}</p>
                    <TableContainer>
                        <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('message.common.subtitle.main.category')}</TableCell>
                                    <TableCell>{t('message.common.subtitle.total.count')}</TableCell>
                                    <TableCell>{t('message.common.subtitle.one.subwayline')}</TableCell>
                                    <TableCell>{t('message.common.subtitle.two.subwayline')}</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                            { reports && reports.map(function(item, i) {
                                let sum = item[1] + item[2];
                                return (
                                <TableRow key={i}>
                                    <TableCell>{item[0]}</TableCell>
                                    <TableCell>{sum}</TableCell>
                                    <TableCell>{item[1]}</TableCell>
                                    <TableCell>{item[2]}</TableCell>
                                </TableRow>
                                )
                            })}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <br/>
                    
                    {(excelDatas && excelDatas.length > 0) ?
                    <div className="report-dataroom-button">
                        <div></div>
                        <div className='no-print-page'>
                            <CommonExcelDownload excelDatas={excelDatas} excelHeader={excelTopHeaders} title={`${reportTitle} ${t('message.common.chip.alert.status')}`} filename={`${fileName}.xlsx`} />
                        </div>
                    </div>
                    :
                    (reports && reports.length > 0) ?
                    <div className="report-dataroom-button">
                        <div></div>
                        <div className='no-print-page' style={{color:"#000"}}>
                            <Box sx={{ display: 'flex', color:"#000" }}>
                                {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                            </Box>
                        </div>
                    </div>
                    : ''
                    }

                    <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.chip.alert.list')} &nbsp;&nbsp;({t('message.common.total')} : {pageInfo.totalElements})</p>
                    <TableContainer>
                        <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table">
                            <TableHead>
                                <TableRow>
                                {excelTopHeader2s && excelTopHeader2s.map(function(hd, b) {
                                        return (
                                    <TableCell key={b}>{hd}</TableCell>
                                        )
                                })}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                            { report2s && report2s.map(function(item, i) {
                                return (
                                <TableRow key={i}>
                                    <TableCell>{item[0]}</TableCell>
                                    <TableCell>{item[1]}</TableCell>
                                    <TableCell>{item[2]}</TableCell>
                                    <TableCell>{item[3]}</TableCell>
                                    <TableCell>{item[4]}</TableCell>
                                    <TableCell>{item[5]}</TableCell>
                                    <TableCell>{item[6]}</TableCell>
                                    <TableCell>{item[7]}</TableCell>
                                    <TableCell>{item[8]}</TableCell>
                                    <TableCell>{item[9]}</TableCell>
                                    <TableCell>{item[10]}</TableCell>
                                    <TableCell>{item[11]}</TableCell>
                                </TableRow>
                                )
                            })}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {(excelData2s && excelData2s.length > 0) ?
                    <div className="report-dataroom-button">
                        <div></div>
                        <div className='no-print-page'>
                            <CommonExcelDownload excelDatas={excelData2s} excelHeader={excelTopHeader2s} title={`${reportTitle} ${t('message.common.chip.alert.list')}`} filename={`${fileName2}.xlsx`} />
                        </div>
                    </div>
                    :
                    (report2s && report2s.length > 0) ?
                    <div className="report-dataroom-button">
                        <div></div>
                        <div className='no-print-page' style={{color:"#000"}}>
                            <Box sx={{ display: 'flex', color:"#000" }}>
                                {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                            </Box>
                        </div>
                    </div>
                    : ''
                    }

                    <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>

                </div>
                }
            </div>       
        </div>
    )

}

export default AlertstatusReportReportDataroomAlertstatusReport;